export default __webpack_public_path__ + "static/media/body.64cb92aa.JPG";